export enum ParticleType {
	ROCK_DEBRIS = "ROCK_DEBRIS",
	GREEN_DEBRIS = "GREEN_DEBRIS",
	CONCRETE_DEBRIS = "CONCRETE_DEBRIS",
	WOOD_DEBRIS = "WOOD_DEBRIS",
	METAL_DEBRIS = "METAL_DEBRIS",
	PLASTIC_DEBRIS = "PLASTIC_DEBRIS",
	LEAF_DEBRIS = "LEAF_DEBRIS",
	MISSILE_EXHAUST = "MISSILE_EXHAUST",
	LARGE_EXPLOSION = "LARGE_EXPLOSION",
	LARGE_GROUND_EXPLOSION = "LARGE_GROUND_EXPLOSION",
	BLOOD = "BLOOD",
	BLUE_BLOOD = "BLUE_BLOOD",
	ROBOT_DEBRIS = "ROBOT_DEBRIS",
	LARGE_ROBOT_DEBRIS = "LARGE_ROBOT_DEBRIS",
	BULLET_TRAIL = "BULLET_TRAIL",
	BUBBLE_TRAIL = "BUBBLE_TRAIL",
	DRILL_TRAIL = "DRILL_TRAIL",
	ELECTRO_TRAIL = "ELECTRO_TRAIL",
	MUZZLE_FLASH = "MUZZLE_FLASH",
	MUZZLE_FLASH_GREEN = "MUZZLE_FLASH_GREEN",
	MUZZLE_FLASH_GREEN_WIDE = "MUZZLE_FLASH_GREEN_WIDE",
	MUZZLE_FLASH_BLUE = "MUZZLE_FLASH_BLUE",
	MUZZLE_FLASH_PURPLE_WIDE = "MUZZLE_FLASH_PURPLE_WIDE",
	MUZZLE_FLASH_FIRE = "MUZZLE_FLASH_FIRE",
	MUZZLE_FLASH_WHITE = "MUZZLE_FLASH_WHITE",
	MUZZLE_FLASH_ICE = "MUZZLE_FLASH_ICE",
	MUZZLE_FLASH_BILE = "MUZZLE_FLASH_BILE",
	BLOOD_DRIP = "BLOOD_DRIP",
	BLUE_BLOOD_DRIP = "BLUE_BLOOD_DRIP",
	DAMAGE_SMOKE = "DAMAGE_SMOKE",
	BILE_SMOKE = "BILE_SMOKE",
	BILE_SMOKE_SMALL = "BILE_SMOKE_SMALL",
	STEP_DUST = "STEP_DUST",
	AIR_BLAST_TRAIL = "AIR_BLAST_TRAIL",
	AIR_BLAST_BURST = "AIR_BLAST_BURST",
	ICE_DRIP = "ICE_DRIP",
	ICE_BURST = "ICE_BURST",
	SOLIDIFY_BURST = "SOLIDIFY_BURST",
	SOLIDIFY_MOB_BURST = "SOLIDIFY_MOB_BURST",
	TOXIC_GAS_BURST = "TOXIC_GAS_BURST",
	PLASMA_CLOUD = "PLASMA_CLOUD",
	PLASMA_SPARK = "PLASMA_SPARK",
	GAS_LEAK = "GAS_LEAK",
	JETPACK_FLAME = "JETPACK_FLAME",
	GOLD_SPARKLE = "GOLD_SPARKLE",
	BLACK_HOLE_SUCTION = "BLACK_HOLE_SUCTION",
	BLACK_HOLE_SUCTION_BIG = "BLACK_HOLE_SUCTION_BIG",
	TORN_GROUND_DUST = "TORN_GROUND_DUST",
}
